import React, {Fragment} from "react";
import CommonHeader from "../../components/Headers/CommonHeader";
import AlertForm from "../../components/Modal/components/AlertForm";
import SafeView from "../../components/safeView/SafeView";
import ProtectedContent from "../../components/protectedContent";
import PageURLContextProvider from "../../contexts/pageURLContext";
import {useDisclosure} from "../../hooks/useDisclosure";
import SensorAlertsTable from "./sensorAlertsTable";

const SensorAlertsComponent = () => {
  const {isOpen, onClose, onOpen} = useDisclosure();

  return (
    <SafeView>
      <ProtectedContent perms={["view_alertdefinition"]} showFallback>
        <Fragment>
          <ProtectedContent perms={["add_alertdefinition"]}>
            <CommonHeader
              content={"Add Alert"}
              handleAddClick={onOpen}
              testID={"add_alert"}
            />
          </ProtectedContent>
          {isOpen && (
            <AlertForm
              closeAlertForm={onClose}
              metricType={"sensor-downtime"}
              showAlertForm={isOpen}
            />
          )}
          <SensorAlertsTable />
        </Fragment>
      </ProtectedContent>
    </SafeView>
  );
};

const SensorAlertsPage = () => {
  return (
    <PageURLContextProvider>
      <SensorAlertsComponent />
    </PageURLContextProvider>
  );
};

export default SensorAlertsPage;
